import type { EmpresaTenant } from './models';

/**
 * Empresas que o acesso vai receber. Com grupo(s) econômico(s) selecionado(s), vale a composição ATUAL do cadastro de
 * empresas (empresa.grupoId) — não há seleção individual de empresas nessa etapa. Sem grupo, valem as empresas marcadas.
 */
export const empresasDoAcesso = (grupoIds: number[], empresasMarcadas: number[], empresas: Pick<EmpresaTenant, 'id' | 'grupoId'>[]): number[] =>
  grupoIds.length > 0
    ? empresas.filter(e => e.grupoId != null && grupoIds.includes(e.grupoId)).map(e => e.id)
    : empresasMarcadas;

export const alternarGrupo = (grupoIds: number[], grupoId: number): number[] =>
  grupoIds.includes(grupoId) ? grupoIds.filter(id => id !== grupoId) : [...grupoIds, grupoId];
